import RotativeExpandMoreIcon from './RotativeExpandMoreIcon';

export default RotativeExpandMoreIcon;
